module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av303-44309b29c9747b644a71ae339508a8eb.jpg";